import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Warning: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <circle cx='390' cy='540' r='30' />
    <path d='m375 285h30v195h-30z' />
    <path d='m634.33 659.62h-488.66c-9.08 0-17.29-4.52-21.98-12.09-4.5-7.28-4.91-16.19-1.1-23.84l244.33-489.62c4.33-8.67 13.17-14.06 23.07-14.06s18.74 5.39 23.07 14.06l244.33 489.62c3.82 7.65 3.41 16.56-1.1 23.84-4.68 7.57-12.9 12.09-21.98 12.09zm-481.17-30h473.68l-236.84-474.6z' />
  </IconBase>
));

Warning.displayName = 'Warning';

export default Warning;
